import { render, staticRenderFns } from "./productListDescriptionModal.vue?vue&type=template&id=6122b630"
import script from "./productListDescriptionModal.vue?vue&type=script&lang=js"
export * from "./productListDescriptionModal.vue?vue&type=script&lang=js"
import style0 from "./productListDescriptionModal.vue?vue&type=style&index=0&id=6122b630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports